/* tslint:disable */
/* eslint-disable */
/**
 * Knowspread API v1
 *  This document describes API of education system Knowspread. This API is used by AngularJS web application. ##Api path Api lives on path `./api/v1/{resource}` relative to the root of the deployed application. ##Api versioning This api is versioned to allow further updates that would break backward compatibility. Current version is `v1` and it will be finalized when the App is deployed into production. In every response with status code `2xx`, `400`, `401` or `403` is returned `X-API-Version` header with current api version. This value is for checking correct api version used in Android or iOS application. ## Request and Response format Both response and request bodies are of type `application/json` if not noted otherwise.  ## Authentication Client accessing Knowspread application authenticates itself with a `POST` request against endpoint `./api/v1/users/login` through invitation link or with username and password. If the user authentication is successful an user unique identificator `uid` is returned together with an `access-token`, `client` - type of client, which allows to be authenticated on more devices, and information about access token expiration. (Please see corresponding API spec for concrete JSON format of request and response)  Each API call of given client is then authenticated using the returned `access-token`,`client` and `uid` which is passed to the server in header. Server returns `401 - Unauthorized` if the given token is expired or not valid. In case of invalid token, client can request a new one by authenticating against `./api/v1/users/login` again. AccessToken validity is automatically prolonged by using it.  ## Error States  The common [HTTP Response Status Codes](https://github.com/for-GET/know-your-http-well/blob/master/status-codes.md) are used for signaling error states.  Error status codes are specified in first endpoint in API spec - `./api/v1/`.  ##Success code `200` status code is returned on success (it does not matter if it is a Create,Read,Delete or Update operation) ## Common patterns in KnowSpread API  All REST based resources in this follow these rules:  * CREATE (`POST`) - Returns status code `201 (OK)` when the creation of entity is successful. and contains dictionary representing the created entity, * READ (`GET`) - Returns status code `200 (OK)` and dictionary or array of dictionaries representing the entity requested. Dictionary with the same keys is expected by the server when updating the entity. * UPDATE (`PUT`) - Returns status code `200 (OK)` and dictionary that represents state of the entity after modification. * DELETE (`DELETE`) - Returns status code `204 (OK)` upon successful deletion of entity.  ## Date formatting API accepts and returns dates in ISO_8601. For more info see: http://en.wikipedia.org/wiki/ISO_8601 ## Documentation tags * PAGEABLE - this marks this request as pageable. If you want to iterate over pages, set query `\'page\' (integer)` to number requested page. You can set query `\'paginates_per\' (integer)`, what sets records count on one page. This request returns count of total pages, current page and total records count in header. * JOB PROCESSING always - where job scheduled always * JOB PROCESSING sometimes - where job scheduled sometimes * JOB PROCESSING callbacks - where shceduled any jobs to support main action of endpoint e.g. assign content to all users in group etc. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ContentCompetenceAssignment } from './ContentCompetenceAssignment';
import {
    ContentCompetenceAssignmentFromJSON,
    ContentCompetenceAssignmentFromJSONTyped,
    ContentCompetenceAssignmentToJSON,
} from './ContentCompetenceAssignment';
import type { ContentEditorShowResponseLessonsInner } from './ContentEditorShowResponseLessonsInner';
import {
    ContentEditorShowResponseLessonsInnerFromJSON,
    ContentEditorShowResponseLessonsInnerFromJSONTyped,
    ContentEditorShowResponseLessonsInnerToJSON,
} from './ContentEditorShowResponseLessonsInner';
import type { ContentEditorShowResponseMeta } from './ContentEditorShowResponseMeta';
import {
    ContentEditorShowResponseMetaFromJSON,
    ContentEditorShowResponseMetaFromJSONTyped,
    ContentEditorShowResponseMetaToJSON,
} from './ContentEditorShowResponseMeta';
import type { ContentEditorShowResponseMetaContent } from './ContentEditorShowResponseMetaContent';
import {
    ContentEditorShowResponseMetaContentFromJSON,
    ContentEditorShowResponseMetaContentFromJSONTyped,
    ContentEditorShowResponseMetaContentToJSON,
} from './ContentEditorShowResponseMetaContent';
import type { ContentEditorShowResponseStudyMaterialsInner } from './ContentEditorShowResponseStudyMaterialsInner';
import {
    ContentEditorShowResponseStudyMaterialsInnerFromJSON,
    ContentEditorShowResponseStudyMaterialsInnerFromJSONTyped,
    ContentEditorShowResponseStudyMaterialsInnerToJSON,
} from './ContentEditorShowResponseStudyMaterialsInner';
import type { UserBasicInfo } from './UserBasicInfo';
import {
    UserBasicInfoFromJSON,
    UserBasicInfoFromJSONTyped,
    UserBasicInfoToJSON,
} from './UserBasicInfo';

/**
 * Content editor
 * @export
 * @interface ContentEditorShowResponse
 */
export interface ContentEditorShowResponse {
    /**
     * 
     * @type {number}
     * @memberof ContentEditorShowResponse
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof ContentEditorShowResponse
     */
    content_id: number;
    /**
     * 
     * @type {string}
     * @memberof ContentEditorShowResponse
     */
    content_type: string;
    /**
     * 
     * @type {ContentEditorShowResponseMeta}
     * @memberof ContentEditorShowResponse
     */
    meta: ContentEditorShowResponseMeta;
    /**
     * 
     * @type {boolean}
     * @memberof ContentEditorShowResponse
     */
    is_valid: boolean;
    /**
     * 
     * @type {number}
     * @memberof ContentEditorShowResponse
     */
    time_estimation: number;
    /**
     * 
     * @type {string}
     * @memberof ContentEditorShowResponse
     */
    promo_video_url: string;
    /**
     * 
     * @type {string}
     * @memberof ContentEditorShowResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ContentEditorShowResponse
     */
    description: string;
    /**
     * 
     * @type {number}
     * @memberof ContentEditorShowResponse
     */
    number: number;
    /**
     * 
     * @type {string}
     * @memberof ContentEditorShowResponse
     */
    changelog: string;
    /**
     * 
     * @type {string}
     * @memberof ContentEditorShowResponse
     */
    language: string;
    /**
     * 
     * @type {string}
     * @memberof ContentEditorShowResponse
     */
    promo_image_url: string;
    /**
     * 
     * @type {boolean}
     * @memberof ContentEditorShowResponse
     */
    has_promo_image: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ContentEditorShowResponse
     */
    is_major: boolean;
    /**
     * 
     * @type {string}
     * @memberof ContentEditorShowResponse
     */
    state: string;
    /**
     * 
     * @type {ContentEditorShowResponseMetaContent}
     * @memberof ContentEditorShowResponse
     */
    content: ContentEditorShowResponseMetaContent;
    /**
     * 
     * @type {Array<UserBasicInfo>}
     * @memberof ContentEditorShowResponse
     */
    authors?: Array<UserBasicInfo>;
    /**
     * 
     * @type {Array<UserBasicInfo>}
     * @memberof ContentEditorShowResponse
     */
    guarantors?: Array<UserBasicInfo>;
    /**
     * 
     * @type {Array<ContentEditorShowResponseStudyMaterialsInner>}
     * @memberof ContentEditorShowResponse
     */
    study_materials?: Array<ContentEditorShowResponseStudyMaterialsInner>;
    /**
     * 
     * @type {Array<ContentCompetenceAssignment>}
     * @memberof ContentEditorShowResponse
     */
    competences?: Array<ContentCompetenceAssignment>;
    /**
     * 
     * @type {Array<ContentEditorShowResponseLessonsInner>}
     * @memberof ContentEditorShowResponse
     */
    lessons?: Array<ContentEditorShowResponseLessonsInner>;
}

/**
 * Check if a given object implements the ContentEditorShowResponse interface.
 */
export function instanceOfContentEditorShowResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "content_id" in value;
    isInstance = isInstance && "content_type" in value;
    isInstance = isInstance && "meta" in value;
    isInstance = isInstance && "is_valid" in value;
    isInstance = isInstance && "time_estimation" in value;
    isInstance = isInstance && "promo_video_url" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "description" in value;
    isInstance = isInstance && "number" in value;
    isInstance = isInstance && "changelog" in value;
    isInstance = isInstance && "language" in value;
    isInstance = isInstance && "promo_image_url" in value;
    isInstance = isInstance && "has_promo_image" in value;
    isInstance = isInstance && "is_major" in value;
    isInstance = isInstance && "state" in value;
    isInstance = isInstance && "content" in value;

    return isInstance;
}

export function ContentEditorShowResponseFromJSON(json: any): ContentEditorShowResponse {
    return ContentEditorShowResponseFromJSONTyped(json, false);
}

export function ContentEditorShowResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContentEditorShowResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'content_id': json['content_id'],
        'content_type': json['content_type'],
        'meta': ContentEditorShowResponseMetaFromJSON(json['meta']),
        'is_valid': json['is_valid'],
        'time_estimation': json['time_estimation'],
        'promo_video_url': json['promo_video_url'],
        'name': json['name'],
        'description': json['description'],
        'number': json['number'],
        'changelog': json['changelog'],
        'language': json['language'],
        'promo_image_url': json['promo_image_url'],
        'has_promo_image': json['has_promo_image'],
        'is_major': json['is_major'],
        'state': json['state'],
        'content': ContentEditorShowResponseMetaContentFromJSON(json['content']),
        'authors': !exists(json, 'authors') ? undefined : ((json['authors'] as Array<any>).map(UserBasicInfoFromJSON)),
        'guarantors': !exists(json, 'guarantors') ? undefined : ((json['guarantors'] as Array<any>).map(UserBasicInfoFromJSON)),
        'study_materials': !exists(json, 'study_materials') ? undefined : ((json['study_materials'] as Array<any>).map(ContentEditorShowResponseStudyMaterialsInnerFromJSON)),
        'competences': !exists(json, 'competences') ? undefined : ((json['competences'] as Array<any>).map(ContentCompetenceAssignmentFromJSON)),
        'lessons': !exists(json, 'lessons') ? undefined : ((json['lessons'] as Array<any>).map(ContentEditorShowResponseLessonsInnerFromJSON)),
    };
}

export function ContentEditorShowResponseToJSON(value?: ContentEditorShowResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'content_id': value.content_id,
        'content_type': value.content_type,
        'meta': ContentEditorShowResponseMetaToJSON(value.meta),
        'is_valid': value.is_valid,
        'time_estimation': value.time_estimation,
        'promo_video_url': value.promo_video_url,
        'name': value.name,
        'description': value.description,
        'number': value.number,
        'changelog': value.changelog,
        'language': value.language,
        'promo_image_url': value.promo_image_url,
        'has_promo_image': value.has_promo_image,
        'is_major': value.is_major,
        'state': value.state,
        'content': ContentEditorShowResponseMetaContentToJSON(value.content),
        'authors': value.authors === undefined ? undefined : ((value.authors as Array<any>).map(UserBasicInfoToJSON)),
        'guarantors': value.guarantors === undefined ? undefined : ((value.guarantors as Array<any>).map(UserBasicInfoToJSON)),
        'study_materials': value.study_materials === undefined ? undefined : ((value.study_materials as Array<any>).map(ContentEditorShowResponseStudyMaterialsInnerToJSON)),
        'competences': value.competences === undefined ? undefined : ((value.competences as Array<any>).map(ContentCompetenceAssignmentToJSON)),
        'lessons': value.lessons === undefined ? undefined : ((value.lessons as Array<any>).map(ContentEditorShowResponseLessonsInnerToJSON)),
    };
}

